import React from 'react';
import { Switch } from 'react-router-dom';
import Certificados from '../pages/certificados';
import NovoCertificado from '../pages/certificados/NovoCertificado';
import CreateAccount from '../pages/CreateAccount';
import Dashboard from '../pages/Dashboard';
import Forgot from '../pages/Forgot';
import Hierarquia from '../pages/Hierarquia';
import Notfound from '../pages/Notfound';
import Perfil from '../pages/perfil';
import SignIn from '../pages/SignIn';
import Usuarios from '../pages/Usuarios';
import EditarUsuario from '../pages/Usuarios/EditarUsuario';
import { usePermissoes } from '../services/hooks/usePermissoes';
import { Constants } from '../shared/constants';
import Route from './Route';

// import Comissoes from '../pages/comissoes';

const Routes: React.FC = () => {
  const { permite } = usePermissoes();
  const { PERMISSAO_VER_HIERARQUIA, PERMISSAO_CONVIDAR_PARCEIROS } = Constants;
  return (
    <Switch>
      <Route exact path="/" component={SignIn} />
      <Route exact path="/forgot" component={Forgot} />
      <Route exact path="/create-account" component={CreateAccount} />
      <Route
        exact
        path="/create-account/:idConvite"
        component={CreateAccount}
      />
      <Route exact path="/dashboard" component={Dashboard} isPrivate />
      <Route exact path="/perfil" component={Perfil} isPrivate />

      {/* <Route exact path="/vendas-erp" component={VendasERP} isPrivate /> */}
      {/* <Route
        exact
        path="/vendas-erp/nova-venda"
        component={NovaVenda}
        isPrivate
      /> */}

      <Route exact path="/certificados/" component={Certificados} isPrivate />
      <Route
        exact
        path="/certificados/novo-certificado"
        component={NovoCertificado}
        isPrivate
      />
      <Route
        exact
        path="/certificados/detalhes/:idCertificado"
        component={Certificados}
        isPrivate
      />
      <Route
        exact
        path="/certificados/agendamento/:idCertificado"
        component={Certificados}
        isPrivate
      />
      {/* <Route exact path="/meus-clientes" component={MeusClientes} isPrivate /> */}
      {/* <Route exact path="/saques" component={Saques} isPrivate /> */}

      {/* <Route exact path="/comissoes/" component={Comissoes} isPrivate /> */}
      {permite(PERMISSAO_CONVIDAR_PARCEIROS) && (
        <Route exact path="/usuarios" component={Usuarios} isPrivate />
      )}
      <Route exact path="/usuarios/:id" component={EditarUsuario} isPrivate />
      {permite(PERMISSAO_VER_HIERARQUIA) && (
        <Route exact path="/hierarquia" component={Hierarquia} isPrivate />
      )}

      <Route exact path="*" component={Notfound} isPrivate />
    </Switch>
  );
};

export default Routes;
